import { BlocksIconEllipsis } from 'blocks-nextjs/blocks-web-components/components/icon/icons/ellipsis';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconEllipsis = createComponent({ react: React, tagName: 'cat-icon-ellipsis', elementClass: BlocksIconEllipsis });
